import { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const FreieKapazitaetenHalle = () => {
  const [ampelStatus, setAmpelStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchAmpelStatus();
  }, []);

  const fetchAmpelStatus = async () => {
    try {
      const response = await fetch(`${API_URL}/api/ampel/halle`);
      if (response.ok) {
        const data = await response.json();
        setAmpelStatus(data);
      }
    } catch (err) {
      console.error('Failed to fetch ampel status:', err);
    } finally {
      setLoading(false);
    }
  };

  const getStatus = (key) => {
    if (ampelStatus && ampelStatus[key]) {
      return ampelStatus[key];
    }
    // Default values
    const defaults = {
      behandlungspflege: 'green',
      grundpflege: 'green',
      hauswirtschaft: 'green',
      beratung: 'green'
    };
    return defaults[key] || 'green';
  };

  const kapazitaeten = [
    {
      key: 'behandlungspflege',
      title: 'Behandlungspflege nach SGB V',
      description: 'Welche Leistungen hierunter zählen, finden Sie unter Leistungen'
    },
    {
      key: 'grundpflege',
      title: 'Grundpflege nach SGB XI',
      description: 'Welche Leistungen hierunter zählen, finden Sie unter Leistungen'
    },
    {
      key: 'hauswirtschaft',
      title: 'Hauswirtschaft & Betreuung',
      description: 'Welche Leistungen hierunter zählen, finden Sie unter Leistungen'
    },
    {
      key: 'beratung',
      title: 'Beratungsbesuche nach §37,3 SGB XI',
      description: 'Welche von den Pflegekassen gefordert werden'
    }
  ];

  const getStatusColor = (status) => {
    switch(status) {
      case 'green': return 'bg-green-500';
      case 'yellow': return 'bg-yellow-500';
      case 'red': return 'bg-red-500';
      default: return 'bg-gray-500';
    }
  };

  const formatDate = () => {
    const now = new Date();
    return now.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-turquoise-50 to-white">
      <Header />
      
      <section className="relative py-20 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-turquoise-400 to-turquoise-300 opacity-10"></div>
        <div className="container mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Freie Kapazitäten Halle (Saale)</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">Aktuelle Verfügbarkeit unserer Pflegeleistungen in Halle (Saale)</p>
        </div>
      </section>

      <section className="py-8 px-4 bg-white">
        <div className="container mx-auto max-w-4xl">
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-6 border-l-4 border-green-500">
              <div className="bg-green-500 w-12 h-12 rounded-full mx-auto mb-4"></div>
              <p className="font-semibold text-gray-900">Grüne Ampel</p>
              <p className="text-sm text-gray-600 mt-2">Wir nehmen aktuell Klienten auf</p>
            </div>
            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-2xl p-6 border-l-4 border-yellow-500">
              <div className="bg-yellow-500 w-12 h-12 rounded-full mx-auto mb-4"></div>
              <p className="font-semibold text-gray-900">Gelbe Ampel</p>
              <p className="text-sm text-gray-600 mt-2">Nur noch für akute Notfälle verfügbar</p>
            </div>
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-6 border-l-4 border-red-500">
              <div className="bg-red-500 w-12 h-12 rounded-full mx-auto mb-4"></div>
              <p className="font-semibold text-gray-900">Rote Ampel</p>
              <p className="text-sm text-gray-600 mt-2">Leider keine Kapazitäten</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-5xl">
          <div className="bg-white rounded-3xl shadow-2xl p-8 mb-8">
            <p className="text-center text-gray-600 mb-8"><strong>Stand: {formatDate()}</strong></p>
            
            {loading ? (
              <div className="text-center py-8">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-turquoise-400 mx-auto"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {kapazitaeten.map((item, index) => (
                  <div key={index} className="flex items-start space-x-6 p-6 rounded-2xl bg-gradient-to-r from-gray-50 to-white border border-gray-200 hover:shadow-lg transition-shadow">
                    <div className={`${getStatusColor(getStatus(item.key))} w-16 h-16 rounded-full flex-shrink-0 shadow-lg`}></div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-gradient-to-br from-turquoise-400 to-turquoise-500 text-white">
        <div className="container mx-auto text-center max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Fragen zu unseren Kapazitäten in Halle?</h2>
          <p className="text-xl mb-8">Kontaktieren Sie uns direkt für aktuelle Informationen</p>
          <a href="tel:034568669465" className="inline-block bg-white text-turquoise-400 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all shadow-lg">
            0345-68669465
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FreieKapazitaetenHalle;
